// extracted by mini-css-extract-plugin
var _1 = "v0Afwp58tKusTZKYsEwN";
var _2 = "muTkOw5auaP7jdGYt3B6";
export { _1 as "container", _2 as "gun_info" }
